import {
    COLOR_RA_BILLABLE,
    COLOR_RA_BILLED,
    COLOR_REJECTED,
    COLOR_TO_BE_ANALYZED,
    COLOR_WITHOUT_RA, ERROR,
    IMPORTED, PROCESSING,
    RA_BILLED,
    RA_TO_BE_INVOICED,
    REJECTED,
    TO_BE_ANALYZED,
    WITHOUT_RA
} from "./FuelsConstants";
import { useTranslation } from "react-i18next";


export const useFuelStatuses = () => {

    const {t} = useTranslation(['finance'], {keyPrefix: 'fuel.filters.statuses'});

    const getStatusColor = (status: string) => {
        switch (status) {
            case WITHOUT_RA: return COLOR_WITHOUT_RA;
            case TO_BE_ANALYZED: return COLOR_TO_BE_ANALYZED;
            case RA_TO_BE_INVOICED: return COLOR_RA_BILLABLE;
            case RA_BILLED: return COLOR_RA_BILLED;
            case REJECTED: return COLOR_REJECTED;
        }
    };
    const getStatus = (status: string) => {
        switch (status) {

            case WITHOUT_RA:        return t('WITHOUT_RA');
            case TO_BE_ANALYZED:    return t('TO_BE_ANALYZED');
            case RA_TO_BE_INVOICED: return t('RA_TO_BE_INVOICED');
            case RA_BILLED:         return t('RA_BILLED');
            case REJECTED:         return t('REJECTED');

            default : return '-'
        }
    };

    const getReportStatus = (status: string) => {
        switch (status) {
            case IMPORTED:      return t('IMPORTED');
            case ERROR:         return t('ERROR');
            case PROCESSING:    return t('PROCESSING');

            default : return '-'
        }
    };

    return {
        getStatus, getReportStatus, getStatusColor
    }
}